export enum UserPermissions {
    EditStampPeriod = 2,
    ViewConstructionPeriod = 3,
    EditConstructionPeriod = 4,
    ViewPublishedPeriod = 6,
    EditPublishedPeriod = 7,
    EditLeavePeriods = 1,
    EditSicknessCases = 5,
    ChangeStampsToConstruction = 8,
    ProposeRoster = 9,
    AcceptProposal = 10,
    ShowRoster = 11,
    WishInputClose = 12,
    EditRosterComment = 13,
    ReorderUsers = 14,
    EditEmploymentComment = 15,
    EditWishes = 16,
    SetRightsDerived = 17,
    EditWorkSchedule = 18,
    PutOwnRosterPeopleOnRoster = 20,
    ProposeDeploymentsPublishedPeriod = 49,
    ProposeDeploymentsConstructionPeriod = 50,
    EditRosterRankSets = 52,
}
